/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Text } from '@radix-ui/themes';

import { styled } from 'fierry/react';

import Icon from 'solis/claude/primitive/icon';


const Container = styled(Text)`
  display: inline-flex;
  align-items: center;
  gap: 1px;
  font-variant-numeric: tabular-nums;
`;


export default ({ icon, text, size = '1', color = 'gray' }) =>
(
  <Container size = {size} color = {color}>
    <Icon size = {size}>{icon}</Icon>
    {text}
  </Container>
);
